var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAzerbaijan(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_222_35323)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 20C40 17.5536 39.56 15.2101 38.756 13.0436L20 12.174L1.24398 13.0435C0.440078 15.2101 0 17.5536 0 20C0 22.4465 0.440078 24.79 1.24398 26.9565L20 27.8261L38.756 26.9566C39.56 24.79 40 22.4465 40 20Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0002 40C28.5995 40 35.9303 34.5725 38.7562 26.9565H1.24414C4.07 34.5725 11.4009 40 20.0002 40Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.24414 13.0436H38.7563C35.9303 5.42756 28.5995 6.10352e-05 20.0002 6.10352e-05C11.4009 6.10352e-05 4.07 5.42756 1.24414 13.0436Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4346 25.6522C17.313 25.6522 14.7824 23.1216 14.7824 20C14.7824 16.8785 17.313 14.3478 20.4346 14.3478C21.4079 14.3478 22.3237 14.5939 23.1233 15.0272C21.8689 13.8006 20.1536 13.0435 18.2607 13.0435C14.4187 13.0435 11.3042 16.158 11.3042 19.9999C11.3042 23.8419 14.4187 26.9564 18.2607 26.9564C20.1536 26.9564 21.869 26.1993 23.1233 24.9727C22.3237 25.4061 21.4079 25.6522 20.4346 25.6522Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7822 16.087L25.5309 18.1925L27.5491 17.233L26.5897 19.2513L28.6952 20L26.5897 20.7488L27.5491 22.7671L25.5309 21.8075L24.7822 23.9131L24.0336 21.8075L22.0152 22.7671L22.9748 20.7488L20.8691 20L22.9748 19.2513L22.0152 17.233L24.0336 18.1925L24.7822 16.087Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_222_35323"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzerbaijan);
export default __webpack_public_path__ + "static/media/azerbaijan.f4ffe17f44b3968c702275cee385ae90.svg";
export { ForwardRef as ReactComponent };